import React, { useEffect, useRef } from 'react';
import styles from './ProductDetailModal.module.css';

const ProductDetailModal = ({ isOpen, onClose, children }) => {
  const modalRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleOutsideClick);
    }

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className={styles.overlay}>
      <div className={`modal-content ${styles.content}`} ref={modalRef}>
      <button className={styles.close} onClick={onClose}>X</button>
        {children}
        
      </div>
    </div>
  );
};

export default ProductDetailModal;